import { Heading, Text } from '@afterpaytouch/core'
import { Trans, useTranslation } from 'next-i18next'
import React from 'react'
import { IdentityDocument } from '../../../model'
import { useIsPartialVerified } from '../../../state'
import { useCheckoutSizes } from '../../../utils/responsive'
import { Wrapper } from '../../Wrapper'
import { useIsRetryPageContext } from '../helper'
import { useHeadingAndDescription } from '../utils'

interface Props {
  documentType: IdentityDocument
}

export const HardIdHeader: React.FC<Props> = ({ documentType }) => {
  const { t } = useTranslation()
  const { heading, description } = useHeadingAndDescription(t, documentType)
  const { headingSize, textSize } = useCheckoutSizes()
  const isRetryPage = useIsRetryPageContext()
  const isRetryMode = useIsPartialVerified() && isRetryPage

  return (
    <>
      <Heading size={headingSize}>{heading}</Heading>
      {isRetryMode && (
        <Wrapper marginType='Small'>
          <Text size={textSize}>
            <Trans i18nKey={description} />
          </Text>
        </Wrapper>
      )}
    </>
  )
}
